module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"invalid":"@:labels.invalid","required":"@:labels.required","save":"@:labels.save","title":"Preferences"},"fr":{"invalid":"@:labels.invalid","required":"@:labels.required","save":"@:labels.save","title":"Préférences"}}')
  delete Component.options._Ctor
}
